<template>
  <div
    class="nlp__burger"
    :class="{ 'nlp__burger--open': getBurgerMenuState }"
    @click="handleBurgerClick"
  >
    <div class="nlp__burger-wrapper">
      <div class="nlp__burger-line nlp__burger-line--top" />
      <div class="nlp__burger-line nlp__burger-line--center" />
      <div class="nlp__burger-line nlp__burger-line--bottom" />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'NlpBurger',
  computed: {
    ...mapGetters('nlp', ['getBurgerMenuState']),
  },
  methods: {
    ...mapMutations('nlp', ['SET_BURGER_MENU_STATE']),
    handleBurgerClick() {
      this.SET_BURGER_MENU_STATE(!this.getBurgerMenuState)
    },
  },
}
</script>

<style scoped>
.nlp__burger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background-color: #F4F7F9;
  border-radius: 100%;
}
.nlp__burger-wrapper {
  transition: all 0.3s ease;
}
.nlp__burger-line {
  width: 16px;
  height: 2px;
  background-color: #5A627D;
  border-radius: 1px;
  transition: all 0.3s ease;
  transform-origin: left center;
  position: relative;
}
.nlp__burger-line + .nlp__burger-line {
  margin-top: 4px;
}

.nlp__burger--open .nlp__burger-wrapper {
  transform: translate(2px, 0);
}
.nlp__burger--open .nlp__burger-line--top {
  width: 17px;
  transform: rotate(45deg);
}
.nlp__burger--open .nlp__burger-line--center {
  opacity: 0;
}
.nlp__burger--open .nlp__burger-line--bottom {
  width: 17px;
  transform: rotate(-45deg);
}
</style>